// Who can subscribe to what — the one rule behind every place the app offers a
// subscription (product cards, the Subscribe page, the cart's Subscription
// order type). A product can be subscribed to only when the store has
// subscriptions switched on AND the store marked that product as available for
// subscription. The server enforces the same rule (backend/subscription_rules.py),
// so nothing here is the only line of defence; this keeps the app from offering
// what the server would refuse.

export const storeOffersSubscriptions = (storeSettings) =>
  storeSettings?.tenant_features?.subscriptions === true;

export const canSubscribeToProduct = (storeSettings, product) =>
  storeOffersSubscriptions(storeSettings) && !!product?.is_subscription_available;

// The cart lines that cannot be turned into a subscription, given the store's
// current catalogue: the product is no longer in it, or is not marked as
// available for subscription. The cart creates one subscription per line, so
// this is checked for the whole cart before anything is sent.
export const cartItemsNotSubscribable = (items, products) => {
  const subscribable = new Set(
    (products || []).filter((p) => p.is_subscription_available).map((p) => p.id)
  );
  return (items || []).filter((item) => !subscribable.has(item.product_id));
};

// What to tell the customer about those lines; null when every line is fine.
export const notSubscribableMessage = (blockedItems) => {
  const names = [...new Set((blockedItems || []).map((item) => item.product_name))];
  if (names.length === 0) return null;
  const [verb, them] = names.length === 1 ? ["isn't", 'it'] : ["aren't", 'them'];
  return `${names.join(', ')} ${verb} available for subscription. Remove ${them} from your cart, or choose One-Time to order ${them}.`;
};
